import React, { useContext, useEffect, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom';
import DataTable from 'react-data-table-component';
import moment from 'moment';
import axios from 'axios';
import BaseUrl from '../../../utils/BaseUrl';
import CustomerStyle from '../../../utils/customerStyle';
import { UserContext } from '../../../utils/User_check';
import ContentSection from '../../Content';


const url = BaseUrl();
const customerStyle = CustomerStyle();
const InterventionWorkFlow = () => {
    const [itemsListFilter,setItemsListFilter] = useState([]);
    const [loading,setLoading] = useState(false);
    const [dataAssets,setDataAssets] = useState([]);
    const [stepNext,setStepNext] = useState('CONFIRMATION DEMANDE');

    const {user,permissions} = useContext(UserContext);
    const navigate = useNavigate();



    const columns = [
        {
            name: 'DATE',
            selector: row => moment(row?.intervention?.created_at).format('Do MMMM yy HH:mm'),
            sortable: true,
        },
        {
            name: 'CODE DU TICKET',
            selector: row => `${row?.intervention.code}`,
            sortable: true, 
        },
        {
            name: 'TERRITOIRE',
            selector: row => row?.intervention.d_territoire,
            sortable: true,
        },
        {
            name: 'PDV',
            selector: row => row?.intervention.d_pdv,
            sortable: true,
        },
      
        {
          name: "STATUT DEMANDE",
          selector : row => (
            <>
                    <span className={ row?.intervention.status == "Terminée"? "badge bg-success":row?.intervention.status=="Réfusée"?"badge bg-danger":"badge bg-warning"}>{row?.intervention.status}</span>  
            </>
          )
        },
        {
            name: 'AUTEUR',
            selector: row => (
               <>
                <b>{row.auteur.use_nom} {row.auteur.use_prenom}</b> 
               </> 
            ),
            sortable: true,
        },
  
    ];

    useEffect(()=>{ 
        get_demande_assets_list();
    },[]);


    function get_demande_assets_list(next='CONFIRMATION DEMANDE')
    {  setStepNext(next)
        setLoading(true);
        try {
            axios.get(url.base+'/list-intervention-bylevel?stepNext='+next,{
                headers:{
                    'Content-Type':'application/json',
                    "Authorization": `Bearer ${localStorage.getItem('_token_')}`
                    
                },
            }).then((resp)=>{
                setLoading(false);
                setDataAssets(resp.data.data);
                setItemsListFilter(resp.data.data); 
            })
        } catch (error) {
            setLoading(false);
        }
    }

  const handleRowClicked = (row) => {
    navigate(`/views-intervention/${row?.intervention.uuid}`);
  };

  return (
        <ContentSection ulShownav={"interventions"} navactive={"workflow_intervention"}>
                <div class="container-fluid">
                        <div class="row">
                            <div class="col-lg-12 col-md-12 col-12">
                                
                                <div class="mb-5">
                                    <h3 class="mb-0 ">WorkFlow Intervention</h3>
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-12">
                        
                                <div class="card mb-4">
                                    <div class="card-header">
                                        <div class="row g-2">
                                            <div class="col-md-5 col-lg-3">
                                                {/* <input type="search" class="form-control w-100" placeholder="Recherche ..." /> */}
                                            </div>
                                            <div class="bg-info p-2">
                                                <button to="/materiel/files-import" class={stepNext==='CONFIRMATION DEMANDE' ? "btn btn-success mx-2" : "btn btn-grey mx-2"} onClick={()=>get_demande_assets_list('CONFIRMATION DEMANDE')}>CONFIRMATION DEMANDE { stepNext=== 'CONFIRMATION DEMANDE' ? `(${dataAssets.length})` :""}</button>
                                                <button to="/materiel/files-import" class={stepNext=== 'VALIDATION DEMANDE' ? "btn btn-success mx-2" : "btn btn-grey mx-2"} onClick={()=>get_demande_assets_list('VALIDATION DEMANDE')}>VALIDATION DEMANDE{ stepNext=== 'VALIDATION DEMANDE' ? `(${dataAssets.length})` :""}</button>
                                                <button to="/materiel/files-import" class={stepNext=== 'SOUMISSION DEVIS' ? "btn btn-success mx-2" : "btn btn-grey mx-2"} onClick={()=>get_demande_assets_list('SOUMISSION DEVIS')}>SOUMISSION DEVIS { stepNext=== 'SOUMISSION DEVIS' ? `(${dataAssets.length})` :""}</button>
                                                <button to="/materiel/files-import" class={stepNext=== 'VALIDATION DEVIS' ? "btn btn-success mx-2" : "btn btn-grey mx-2"} onClick={()=>get_demande_assets_list('VALIDATION DEVIS')}>VALIDATION DEVIS { stepNext=== 'VALIDATION DEVIS' ? `(${dataAssets.length})` :""}</button>
                                                <button to="/materiel/files-import" class={stepNext=== 'CONFIRMATION TACHES' ? "btn btn-success mx-2" : "btn btn-grey mx-2"} onClick={()=>get_demande_assets_list('CONFIRMATION TACHES')}>CONFIRMATION COMMERCIAL{ stepNext=== 'CONFIRMATION TACHES' ? `(${dataAssets.length})` :""}</button>
                                                <button to="/materiel/files-import" class={stepNext=== 'CLOTURER DEMANDE' ? "btn btn-success mx-2" : "btn btn-grey mx-2"} onClick={()=>get_demande_assets_list('CLOTURER DEMANDE')}>CLOTURER LA DEMANDE{ stepNext=== 'CLOTURER DEMANDE' ? `(${dataAssets.length})` :""}</button>
                                            </div>
                                        
                                        
                                        </div>
                                    </div>
                                    <div class="card-body">
                                        <div class="table-responsive table-card">
                                            <DataTable 
                                                columns={columns} 
                                                data={itemsListFilter}
                                                customStyles={customerStyle}
                                                pagination
                                                selectableRows
                                                progressPending={loading}
                                                onRowClicked={handleRowClicked}
                                                pointerOnHover
                                                highlightOnHover
                                                progressComponent={
                                                    <>
                                                    <div class="text-center">
                                                        <div class="spinner-border" role="status">
                                                        <span class="visually-hidden">Loading...</span>
                                                        </div>
                                                    </div>
                                                    </>
                                                } 
                                            />

                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                </div>
        </ContentSection>
  )
}

export default InterventionWorkFlow;